export const getLocationById = (state, locationId) =>
  state.locations?.locationsById &&
  state.locations.locationsById[`${locationId}`.toUpperCase()];

export const getLocationProviders = (state, locationId) =>
  state.locations?.providersByLocationId &&
  state.locations?.providersByLocationId[`${locationId}`.toUpperCase()];
